module.exports = "<div zf-modal=\"\" id=\"{{$ctrl.idDialog}}\">\n  <a zf-close=\"{{$ctrl.idDialog}}\" ng-click=\"$ctrl.closeFunction()\" data-close class=\"close-button\">×</a>\n  <h4>{{$ctrl.title}}</h4>\n  <p>{{$ctrl.text}}</p>\n  <div class=\"action-buttons\">\n    <a ng-if=\"$ctrl.isconfirm\" zf-close=\"{{$ctrl.idDialog}}\" ng-click=\"$ctrl.closeFunction()\" class=\"secondary button\">Annulla</a>\n    <a ng-if=\"$ctrl.isconfirm\" zf-close=\"{{$ctrl.idDialog}}\" ng-click=\"$ctrl.confirmFunction()\" class=\"button\">Conferma</a>\n  </div>\n</div>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/common/components/modal/modal.html
 ** module id = 355
 ** module chunks = 0
 **/